import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer
class CheckboxGroup extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    items: PropTypes.any,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    newLayout: PropTypes.bool,
  }

  /*
   *  IMPORTANT: Never add preventDefault() to the onChange event,
   *  because that will prevent the checkbox UI state from updating
   */

  render() {
    const {
      items, className, disabled, onChange, newLayout, ...rest
    } = this.props;
    return (
      <div className={`form-checkbox ${className || ''}`} {...rest}>
        {items.reduce(
          (array, item, index) =>
            array.concat(
              <input
                data-qa={`${item.name}-input`}
                key={`item-${index}`}
                id={`${item.name}-${index}`}
                type="checkbox"
                name={item.name}
                value={item.value}
                checked={item.checked}
                disabled={disabled}
                onChange={onChange}
              />,
              <label
                data-qa={`${item.name}-label`}
                key={`label-${index}`}
                htmlFor={`${item.name}-${index}`}
                className="form-checkbox-label"
              >{item.label}</label>,
            ),
          [],
        )}
      </div>
    );
  }
}
export default CheckboxGroup;



// WEBPACK FOOTER //
// ./spa/Components/Form/CheckboxGroup.jsx